// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServerError_wrapper__X_ntM","notfound":"ServerError_notfound__bkfBl","notfound404":"ServerError_notfound404__3jlaG","goToHomeBtn":"ServerError_goToHomeBtn__1Txqp"};